export enum TutorialStep {
    ankiConnect = 1,
    deck = 2,
    noteType = 3,
    ankiFields = 4,
    testCard = 5,
    done,
}

export enum Direction {
    up = 1,
    down = 2,
}
